export default "__VITE_ASSET__ByYNZiHv__"